import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";

import useTranslations from "../../../../hooks/useTranslations";
import useViewer from "../../../../hooks/useViewer";

import Button from "../Button";
import { Link } from "../..";
import { PlusIcon } from "../../../icons";

type HeaderProps = {
  onVisibilityChange: () => void;
};

const Header: React.FC<HeaderProps> = ({ onVisibilityChange }) => {
  const t = useTranslations();

  const viewer = useViewer();

  return (
    <div className="relative z-10 flex justify-between flex-shrink-0 h-16 bg-white shadow md:justify-end">
      <button
        className="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
        aria-label="Open sidebar"
        onClick={onVisibilityChange}
      >
        <svg
          className="w-6 h-6"
          stroke="currentColor"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </button>
      {
        viewer.isCapableOfInsertingMads && (
          <div className="flex items-center pr-4">
            <Link variant="button-subtle" to="/mads/new" className="flex items-center">
              {t("header.createMad")}
              <PlusIcon iconClassName='w-4 h-4 ml-1' />
            </Link>
          </div>
        )
      }
    </div>
  );
};

export default Header;
